import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useExecutiveDashboard } from "@/hooks/useExecutiveDashboard";
import { ExecKpiGrid } from "@/components/executive/ExecKpiGrid";
import { AdminGatePlaceholder } from "@/components/executive/AdminGatePlaceholder";
import { ExecTrendChart } from "@/components/executive/ExecTrendChart";
import { ExecNarrative } from "@/components/executive/ExecNarrative";
import { ExecHeroRow } from "@/components/executive/ExecHeroRow";
import { PortfolioTable } from "@/components/executive/PortfolioTable";
import { ThroughputStabilityChart } from "@/components/executive/ThroughputStabilityChart";

export function ExecutiveDashboardPage() {
  const { t } = useTranslation();
  const { orgSlug = "" } = useParams<{ orgSlug: string }>();
  const {
    isAdmin,
    loading,
    families,
    costFamily,
    costItems,
    rollup,
    metrics,
    gateDefects,
    costPerItem,
    portfolioState,
  } = useExecutiveDashboard();

  return (
    <div className="min-w-0 space-y-6 overflow-hidden p-6">
      <h1 className="text-2xl font-semibold">{t("executive.title")}</h1>

      {loading ? (
        <p className="text-muted-foreground">{t("executive.loading")}</p>
      ) : (
        <>
          <ExecHeroRow
            gateDefects={gateDefects}
            costPerItem={costPerItem}
            portfolioAttentionCount={portfolioState.portfolio.attentionCount}
          />
          <ExecNarrative rollup={rollup} />
          <ExecKpiGrid families={families} orgSlug={orgSlug} />

          {isAdmin ? (
            <>
              <ExecKpiGrid families={[costFamily]} orgSlug={orgSlug} />
              <ExecTrendChart items={costItems} />
            </>
          ) : (
            <AdminGatePlaceholder />
          )}

          <ThroughputStabilityChart metrics={metrics} />
          <PortfolioTable portfolio={portfolioState.portfolio} orgSlug={orgSlug} />
        </>
      )}
    </div>
  );
}
